import { localStorageNameAutostart } from "./constants";

export function isDefined(obj: unknown): boolean {
    return typeof obj !== "undefined" && obj !== null;
}

export function isValidTargetRect(targetRect: DOMRect): boolean {
    return targetRect !== null && targetRect.width > 0 && targetRect.height > 0;
}

let autoStartEnabled: boolean =
    localStorage.getItem(localStorageNameAutostart) !== "0";

export function getAutoStartEnabled() {
    return autoStartEnabled;
}

export function setAutoStartEnabled(val: boolean) {
    if (val !== autoStartEnabled) {
        autoStartEnabled = val;
        if (autoStartEnabled) {
            localStorage.removeItem(localStorageNameAutostart);
        } else {
            localStorage.setItem(localStorageNameAutostart, "0");
        }
    }
}
